module.exports = __webpack_public_path__ + "img/maris.6118da7b.jpg";